import React,{useEffect, useLayoutEffect, useState,useRef} from 'react'
import "./Profile.scss"
import EditIcon from "@material-ui/icons/Edit";
import Avatar from "@mui/material/Avatar";
import { useAppSelector } from "../../../redux/hooks";
import FileBase64 from "react-file-base64"
import ClosedCaptionIcon from "@mui/icons-material/ClosedCaption";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import profileUploadIMG from "../../../assets/profileUploadIMG.png";
import points from "../../../assets/pointsProfile.png";
import Edit from "../../../assets/Edit.png";
import Delete from "../../../assets/Delete.png"
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import TextField from '@mui/material/TextField';
import Textarea from '@mui/joy/Textarea';
import { Divider, FormControl } from '@mui/material';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import {GraphQLFetchData} from "./utils/GraphFetchData"
import { Hooks } from './utils/hooks';
import Button from '@mui/material/Button';
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { GlobalHooks } from '../../../utils/Hooks';
import PublishIcon from '@mui/icons-material/Publish'; // Import the Upload icon
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useHistory } from 'react-router-dom'; // Import useHistory from 'react-router-dom'
import { setProfileUserActions } from './store/profileActions';
import { UpdateData } from '../../../APIcalls';
import DefaultImage from "../../../assets/admin.jpg";




const Profile = () => {
    const [anchor, setAnchor] = useState(null);
	const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const {GetUserData,uploadFile,UpdateUser} = GraphQLFetchData()
  const {cookies,setCookie} = GlobalHooks()
  const {updateImage,onChangeUserProfile,onReset,updateUserDataProfileChange,valid,Once} = Hooks()
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const progress = 60
  const {id} = useAppSelector((state) => state.ConnexionReducer.constraintData)
  const newUserData = useAppSelector((state) => state.ProfileReducer.ProfileConstraintsDataUpdated)
  const oldUserData = useAppSelector((state) => state.ProfileReducer.profileConstraintsData)
  const show = useAppSelector((state) => state.ProfileReducer.ShowButton.showRegister)
  const [images, setImages] = useState(null); 
  const [isActive, setIsActive] = useState(false);



  const handleMenuOpen = (event) => {
    setMenuAnchorEl(event.currentTarget);
    setIsActive(!isActive);

};


const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setIsActive(false)
};


  const onChange = (e) => {
   
    const file = e.file
    uploadFile({ variables:  { file, flag:"user" } })
 
}

  function checkObjectCOntained(obj1, obj2) {
    for (let key in obj1) {
      if (!(key in obj2) || obj1[key] !== obj2[key]) {
          return false
        }
    }
return true;
  }
  
  useEffect(()=>{
    if(Once){
        if(checkObjectCOntained(newUserData,oldUserData)){
            dispatch({ type: "SET_divs_show", payload:false})
        }else{
            dispatch({ type: "SET_divs_show", payload:true})
        }
    }
  },[Once,newUserData])


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
        uploadFile({ variables:  { file, flag:"user" } })

      dispatch(setProfileUserActions({
        profileConstraintsDataNameChange:"Vignette",
         profileConstraintsDataValueChange:URL.createObjectURL(file)
                }))
      handleMenuClose()
    }
  };


const updateUserVignette = () =>{
updateImage(newUserData.Id,newUserData.Vignette,newUserData.UserGroupID)
}

function extractImageUrl(inputUrl) {
    if (typeof inputUrl === 'string') {
      const regex = /(https:\/\/[^/]+\/vignettes\/profiles\/[^/]+\.\w+)/;
      const match = inputUrl.match(regex);
  
      if (match && match.length > 1) {
        return match[1];
      }
    }
    return null;
  }
  
  const imageUrl = newUserData?.Vignette ? extractImageUrl(newUserData.Vignette) : null;
  
const checkVlidationInputs = () => {
    return Object.values(valid).every(e => e === true);
  };


  const fileInputRef = useRef(null);

const input = () => {
    fileInputRef.current.click();

}

  const handleDelete = () => {
    dispatch(setProfileUserActions({
        profileConstraintsDataNameChange:"Vignette",
        profileConstraintsDataValueChange:null
    }))
  };
  const handleUpdateUserInfo = () => { 
    const userData = {...newUserData,NumberPerson:newUserData.NumberPerson !=""?newUserData.NumberPerson : 0 }
    delete userData?.Roles
    UpdateUser({variables:{input:userData}})
   }

  return (
    <>
      <div className="ProfileCardTitle">
        {t("profilUser.Information Personnelle")}
      </div>
      <hr className="underLineHeaderProfile" />
      <div className="Profile_Container">
        <div className="card1_2">
          <div
            className={`UploadImageProfile ${
              newUserData.Vignette ? "noBorder" : "animate"
            }`}
          >
            {!newUserData.Vignette  ? (
              <>
                <div className="textUpload">
                  <img
                    src={profileUploadIMG}
                    alt="file upload"
                    style={{
                      marginBottom: "30px",
                      width: "67px",
                      height: "67px",
                      flexShrink: "0",
                    }}
                  />

                  <label for="file">
                    <p className="Modif">
                      {t("profilUser.Cliquez ou deposer")}
                    </p>
                  </label>
                </div>
                <FileBase64
                  accept="image/*"
                  className="boxDragndrop"
                  type="file"
                  multiple={false}
                  onDone={(e) => {
                    onChange(e);
                    setImages(e.base64);
                  }}
                  ref={fileInputRef}
                />
              </>
            ) : (
              <>
                <div className="profilContainer" >
                  <div className="ImageProfil">
                  <img
                      className="imagePicked"
                      src={newUserData.Vignette.includes("/default_user.png") ? DefaultImage 
                      : newUserData.Vignette}
                      alt="The Image That You Picked"
                    />

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="7"
                      viewBox="0 0 30 5"
                      className={`iconUser ${isActive ? "active" : ""}`}
                      onClick={handleMenuOpen}
                      fill="none"
                    >
                      <path
                        d="M24.482 6.226C24.0732 6.22613 23.6684 6.14574 23.2907 5.98942C22.9129 5.8331 22.5697 5.60391 22.2805 5.31493C21.9914 5.02595 21.762 4.68285 21.6054 4.30522C21.4488 3.92758 21.3682 3.52281 21.368 3.114C21.3679 2.7052 21.4483 2.30037 21.6046 1.92263C21.7609 1.54489 21.9901 1.20165 22.2791 0.912483C22.5681 0.623322 22.9112 0.393911 23.2888 0.237347C23.6665 0.0807826 24.0712 0.000131474 24.48 1.60828e-07C25.3057 -0.000265038 26.0976 0.327457 26.6816 0.91107C27.2655 1.49468 27.5938 2.28638 27.594 3.112C27.5943 3.93762 27.2666 4.72953 26.683 5.31352C26.0994 5.8975 25.3077 6.22573 24.482 6.226Z"
                        fill="#029CE5"
                      />
                      <path
                        d="M13.798 6.22601C15.5167 6.22601 16.91 4.83272 16.91 3.11401C16.91 1.3953 15.5167 0.00201416 13.798 0.00201416C12.0793 0.00201416 10.686 1.3953 10.686 3.11401C10.686 4.83272 12.0793 6.22601 13.798 6.22601Z"
                        fill="#029CE5"
                      />
                      <path
                        d="M3.112 6.22601C4.83071 6.22601 6.224 4.83272 6.224 3.11401C6.224 1.3953 4.83071 0.00201416 3.112 0.00201416C1.39329 0.00201416 0 1.3953 0 3.11401C0 4.83272 1.39329 6.22601 3.112 6.22601Z"
                        fill="#029CE5"
                      />
                    </svg>
                  </div>
                  <div className="button-container">
                    <Button
                      onClick={() =>{
                        dispatch(
                          setProfileUserActions({
                            profileConstraintsDataNameChange: "Vignette",
                            profileConstraintsDataValueChange: null,
                          })
                        )
                        setCookie("thumbnail","")
                      }}
                      sx={{
                        height: "2.5rem",
                        fontWeight: "600",
                        fontSize: "14px",
                        letterSpacing: "0.4px",
                        lineHeight: "24px",
                        color: "#ABABAB",
                      }}
                      variant="text"
                    >
                      {t("Profile.cancel")}
                    </Button>

                    <Button
                      onClick={() => updateUserVignette()}
                      sx={{
                        height: "2.5rem",
                        fontWeight: "600",
                        fontSize: "14px",
                        letterSpacing: "0.4px",
                        lineHeight: "24px",
                      }}
                      variant="contained"
                    >
                      {t("Profile.register")}
                    </Button>
                  </div>
                </div>
              </>
            )}
          </div>
          <div></div>
        </div>

        <div className="card3">
          <div className="dataChangeProfile">
            <div className="firstPartProfileInputs">
              <FormControl>
                <label className="theGapForSpecialTitles" htmlFor="Nom">
                  {t("profilUser.Nom")} <span className="requiredStar">*</span>
                </label>
                <TextField
                  error={!valid.LastName && newUserData?.LastName?.length > 0}
                  helperText={
                    !valid.LastName && newUserData?.LastName?.length > 0
                      ? t("updateData.input")
                      : ""
                  }
                  id="Nom"
                  sx={{ color: "#E0E0E0", borderRadius: "12px"}}
                  value={newUserData?.LastName}
                  onChange={(e) =>
                    onChangeUserProfile("LastName", e.target.value)
                  }
                  InputProps={{
                    startAdornment: (
                      <PersonOutlineOutlinedIcon
                        sx={{ color: "gray", marginRight: "10px" }}
                      />
                    ),
                  }}
                  className="input"
                />
              </FormControl>
              <FormControl>
                <label className="theGapForSpecialTitles" htmlFor="Prénom">
                  {t("profilUser.Prénom")}{" "}
                  <span className="requiredStar">*</span>
                </label>
                <TextField
                  error={!valid.FirstName && newUserData?.FirstName?.length > 0}
                  helperText={
                    !valid.FirstName && newUserData?.FirstName?.length > 0
                      ? t("updateData.input")
                      : ""
                  }
                  id="Prénom"
                  sx={{ color: "#E0E0E0", borderRadius: "12px" }}
                  value={newUserData?.FirstName}
                  onChange={(e) =>
                    onChangeUserProfile("FirstName", e.target.value)
                  }
                  InputProps={{
                    startAdornment: (
                      <PersonOutlineOutlinedIcon
                        sx={{ color: "gray", marginRight: "10px" }}
                      />
                    ),
                  }}
                  className="input"
                />
              </FormControl>
              <FormControl>
                <label className="theGapForSpecialTitles" htmlFor="Email">
                  {t("profilUser.Email")}{" "}
                  <span className="requiredStar">*</span>
                </label>
                <TextField
                  error={!valid.Email && newUserData?.Email?.length > 0}
                  helperText={
                    !valid.Email && newUserData?.Email?.length > 0
                      ? t("This mail is not valid")
                      : ""
                  }
                  id="Email"
                  sx={{ color: "#E0E0E0", borderRadius: "12px" }}
                  value={newUserData?.Email}
                  onChange={(e) => onChangeUserProfile("Email", e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <EmailOutlinedIcon
                        sx={{ color: "gray", marginRight: "10px" }}
                      />
                    ),
                  }}
                  className="input"
                />
              </FormControl>
              <FormControl>
                <label className="theGapForSpecialTitles" htmlFor="Téléphone">
                  {t("profilUser.Téléphone")}{" "}
                  <span className="requiredStar">*</span>
                </label>
                <TextField
                  error={!valid.Phone && newUserData?.Phone?.length > 0}
                  helperText={
                    !valid.Phone && newUserData?.Phone?.length > 0
                      ? t("updateData.phone")
                      : ""
                  }
                  id="Téléphone"
                  sx={{ color: "#E0E0E0", borderRadius: "12px" }}
                  value={newUserData?.Phone}
                  onChange={(e) => onChangeUserProfile("Phone", e.target.value)}
                  onInput={(e) => {
                    e.preventDefault(); 
                    const inputValue = e.target.value;
                    const numericValue = inputValue.replace(/[^0-9]/g, '');
                    e.target.value = numericValue;
                  }}
                  InputProps={{
                    startAdornment: (
                      <LocalPhoneIcon
                        sx={{ color: "gray", marginRight: "10px" }}
                      />
                    ),
                  }}
                  className="input"
                  type='integer'
                  
                />
              </FormControl>
            </div>
            <FormControl
              sx={{ width: "100%", position: "relative", marginBottom: "1rem" }}
            >
              <label className="theGapForSpecialTitles" htmlFor="Addresse">
                {t("profilUser.Addresse")}{" "}
                <span className="requiredStar">*</span>
              </label>
              <TextField
                error={!valid.Adresse && newUserData?.Adresse?.length > 0}
                helperText={
                  !valid.Adresse && newUserData?.Adresse?.length > 0
                    ? t("updateData.input")
                    : ""
                }
                id="Addresse"
                multiline
                minRows={4}
                value={newUserData?.Adresse}
                onChange={(e) => onChangeUserProfile("Adresse", e.target.value)}
                sx={{ color: "#E0E0E0", borderRadius: "12px", width: "91%" }}
                InputProps={{
                  startAdornment: (
                    <DriveFileRenameOutlineOutlinedIcon
                      sx={{
                        color: "gray",
                        marginRight: "10px",
                        marginBottom: "auto",
                      }}
                    />
                  ),
                }}
                className="inputAdresse"
              />
            </FormControl>
            <div className="firstPartProfileInputs">
              <FormControl>
                <label className="theGapForSpecialTitles" htmlFor="Ville">
                  {t("profilUser.Ville")}
                </label>
                <TextField
                  error={!valid.City && newUserData?.City?.length > 0}
                  helperText={
                    !valid.City && newUserData?.City?.length > 0
                      ? t(("updateData.input"))
                      : ""
                  }
                  id="Ville"
                  sx={{ color: "#E0E0E0", borderRadius: "12px" }}
                  value={newUserData?.City}
                  className="input"
                  onChange={(e) => onChangeUserProfile("City", e.target.value)}
                />
              </FormControl>
              <FormControl>
                <label className="theGapForSpecialTitles" htmlFor="Code_Postal">
                  {t("profilUser.Code Postal")}
                </label>
                <TextField
                  error={
                    !valid.PostalCode && newUserData?.PostalCode?.length > 0
                  }
                  helperText={
                    !valid.PostalCode && newUserData?.PostalCode?.length > 0
                      ? t(("updateData.phone"))
                      : ""
                  }
                  id="Code_Postal"
                  sx={{ color: "#E0E0E0", borderRadius: "12px" }}
                  value={newUserData?.PostalCode}
                  className="input"
                   onInput={(e) => {
                    e.preventDefault(); 
                    const inputValue = e.target.value;
                    const numericValue = inputValue.replace(/[^0-9]/g, '');
                    e.target.value = numericValue;
                  }}
                  onChange={(e) =>
                    onChangeUserProfile("PostalCode", e.target.value)
                  }
                />
              </FormControl>
              <FormControl>
                <label className="theGapForSpecialTitles" htmlFor="Société">
                  {t("profilUser.Société")}
                </label>
                <TextField
                  error={!valid.Society && newUserData?.Society?.length > 0}
                  helperText={
                    !valid.Society && newUserData?.Society?.length > 0
                      ? t(("updateData.input"))
                      : ""
                  }
                  id="Société"
                  sx={{ color: "#E0E0E0", borderRadius: "12px" }}
                  value={newUserData?.Society}
                  className="input"
                  onChange={(e) =>
                    onChangeUserProfile("Society", e.target.value)
                  }
                />
              </FormControl>
              <FormControl>
                <label
                  className="theGapForSpecialTitles"
                  htmlFor="Nombre_de_Personnage"
                >
                  {t("profilUser.Nombre de Personnage")}
                </label>
                <TextField
                  error={!valid.NumberPerson && newUserData?.NumberPerson?.length > 0}
                  helperText={
                    !valid.NumberPerson && newUserData?.NumberPerson?.length > 0
                      ? t(("updateData.phone"))
                      : ""
                  }
                  id="Nombre_de_Personnage"
                  sx={{ color: "#E0E0E0", borderRadius: "12px" }}
                  value={newUserData?.NumberPerson}
                  className="input"
                  onInput={(e) => {
                    e.preventDefault(); 
                    const inputValue = e.target.value;
                    const numericValue = inputValue.replace(/[^0-9]/g, '');
                    e.target.value = numericValue;
                  }}
                  onChange={(e) =>
                    onChangeUserProfile("NumberPerson", e.target.value)
                  }
                />
                



              </FormControl>
            </div>
            <div className="ProfileActionsButtons">
              <Button
                onClick={handleUpdateUserInfo}
                sx={{
                  height: "2.5rem",
                  fontWeight: "600",
                  fontSize: "14px",
                  letterSpacing: "0.4px",
                  lineHeight: "24px",
                }}
                disabled={!(show && checkVlidationInputs())}
                variant="contained"
              >
                {t("Profile.register")}
              </Button>
              <Button
                onClick={() => onReset()}
                sx={{
                  height: "2.5rem",
                  fontWeight: "600",
                  fontSize: "14px",
                  letterSpacing: "0.4px",
                  lineHeight: "24px",
                }}
                variant="text"
              >
                {t("Profile.cancel")}
              </Button>
            </div>
          </div>
        </div>
        <Menu
        
          anchorEl={menuAnchorEl}
          open={Boolean(menuAnchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem>
            <div
              className="editClassRow"
              onClick={(e) => {
                input(e);
              }}
            >
              <img
                src={Edit}
                style={{
                  marginRight: "6px",
                  marginTop: "-3px",
                  width: "19.021px",
                  height: "19.207px",
                  flexShrink: "0",
                }}
              />
              <span className="EditItem">
                {t("profilUser.EditUserProfile")}
              </span>
            </div>

            <input
              ref={fileInputRef}
              type="file"
              hidden
              onChange={(e) => {
                handleFileChange(e);
              }}
            />
          </MenuItem>

          <MenuItem onClick={handleMenuClose}>
            <div className="editClassRow">
              <img
                src={Delete}
                style={{
                  marginRight: "6px",
                  marginTop: "-3px",
                  width: "20px",
                  height: "20.5px",
                  flexShrink: "0",
                }}
              />
              <span className="DeleteItem" onClick={handleDelete}>
                {t("profilUser.deleteUserProfile")}
              </span>
            </div>
          </MenuItem>
        </Menu>
        </div>
    </>
  );
}

export default Profile